import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Calendar, AlertTriangle } from 'lucide-react';
import { Restaurant } from '../types';
import { SafetyBadge } from './SafetyBadge';
interface RestaurantCardProps {
  restaurant: Restaurant;
  onClick: (id: string) => void;
  index?: number;
}
export function RestaurantCard({
  restaurant,
  onClick,
  index = 0
}: RestaurantCardProps) {
  const latestInspection = restaurant.inspections[0];
  const violationCount = latestInspection?.violations.length || 0;
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4,
    delay: index * 0.05
  }} onClick={() => onClick(restaurant.id)} className="group bg-white rounded-2xl p-5 shadow-sm ring-1 ring-slate-200 cursor-pointer hover:shadow-md hover:ring-teal-500/50 transition-all duration-200 flex flex-col h-full" role="button" tabIndex={0} onKeyDown={e => e.key === 'Enter' && onClick(restaurant.id)} data-id="element-94">
      <div className="flex justify-between items-start mb-3" data-id="element-95">
        <div data-id="element-96">
          <h3 className="text-lg font-bold text-slate-900 group-hover:text-teal-700 transition-colors line-clamp-1" data-id="element-97">
            {restaurant.name}
          </h3>
          <p className="text-sm font-medium text-slate-500" data-id="element-98">
            {restaurant.cuisine}
          </p>
        </div>
        <SafetyBadge grade={restaurant.currentGrade} data-id="element-99" />
      </div>

      <div className="flex items-start gap-2 text-sm text-slate-600 mb-4" data-id="element-100">
        <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-slate-400" data-id="element-101" />
        <span className="line-clamp-2" data-id="element-102">{restaurant.address}</span>
      </div>

      <div className="mt-auto pt-4 border-t border-slate-100 flex items-center justify-between text-xs text-slate-500" data-id="element-103">
        <div className="flex items-center gap-1.5" data-id="element-104">
          <Calendar className="w-4 h-4 text-slate-400" data-id="element-105" />
          <span data-id="element-106">
            Inspected{' '}
            {new Date(restaurant.lastInspectionDate).toLocaleDateString(undefined, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          })}
          </span>
        </div>
        {violationCount > 0 && <div className="flex items-center gap-1.5 text-amber-600 font-medium bg-amber-50 px-2 py-1 rounded-md" data-id="element-107">
            <AlertTriangle className="w-3.5 h-3.5" data-id="element-108" />
            <span data-id="element-109">
              {violationCount} issue{violationCount !== 1 ? 's' : ''}
            </span>
          </div>}
        {violationCount === 0 && <div className="flex items-center gap-1.5 text-green-600 font-medium bg-green-50 px-2 py-1 rounded-md" data-id="element-110">
            <span data-id="element-111">Perfect score</span>
          </div>}
      </div>
    </motion.div>;
}